import type theme from '#build/ui/input'
import type { DeepPartial } from '@nuxt/ui'

export const inputSlots = {
  root: 'group relative flex w-full items-center',
  base: 'rounded-xl peer transitions-normal w-full truncate border-0 pe-11 disabled:cursor-not-allowed disabled:opacity-100',
  leading: 'absolute inset-y-0 start-0 flex items-center',
  leadingIcon: 'shrink-0 group-data-[state=open]:rotate-180 transitions-normal text-inherit',
  leadingAvatar: 'shrink-0',
  leadingAvatarSize: '',
  trailing: 'absolute inset-y-0 end-0 flex items-center',
  trailingIcon: 'shrink-0 group-data-[state=open]:rotate-180 transitions-normal text-inherit',
}

export const inputVariants = {
  size: {
    md: {
      base: 'gap-1.5 px-3 py-2 text-xs min-h-[35px]',
    },
    lg: {
      base: 'gap-2 px-3 py-2 text-sm min-h-[40px]',
      leadingIcon: 'size-6',
      trailingIcon: 'size-6',
    },
    xl: {
      base: 'gap-2 px-3 py-2 text-base',
      leadingIcon: 'size-6',
      trailingIcon: 'size-6',
    },
  },
  variant: {
    outline: 'bg-transparent rounded-sm disabled:bg-cvt-cloud-500 disabled:text-med-deep-navy disabled:ring-med-deep-navy',
    none: 'bg-transparent rounded-sm ring-transparent',
  },
  type: {
    number: 'text-center',
    file: 'file:transitions-normal file:border-cvt-purple-500 file:text-cvt-purple-500 hover:file:bg-cvt-purple-300 hover:file:text-cvt-purple-700 file:px-2 file:mr-2 file:rounded-sm file:border file:bg-transparent file:font-medium file:outline-hidden',
  },
}

export const inputCompoundVariants = [{
  color: 'neutral',
  variant: 'outline',
  class: {
    base: 'rounded-xl ring-med-deep-navy focus:ring-med-deep-navy text-med-deep-navy placeholder:text-(--ui-text-dimmed) disabled:placeholder:text-(--ui-text-dimmed) ring-2 ring-inset focus:ring-2 focus:ring-inset',
    leading: 'text-med-deep-navy group-focus-within:text-med-deep-navy peer-disabled:text-med-deep-navy',
    trailing: 'text-med-deep-navy group-focus-within:text-med-deep-navy peer-disabled:text-med-deep-navy',
  },
}, {
  color: 'error',
  variant: 'outline',
  class: {
    base: 'rounded-xl ring-red-600 focus:ring-red-600 text-red-600 placeholder:text-red-600 disabled:placeholder:text-med-deep-navy ring-2 ring-inset focus:ring-2 focus:ring-inset',
    leading: 'text-red-600 group-focus-within:text-red-600 peer-disabled:text-med-deep-navy',
    trailing: 'text-red-600 group-focus-within:text-red-600 peer-disabled:text-med-deep-navy',
  },
}, {
  type: 'file',
  error: true,
  class: 'placeholder:text-red-300 file:border-red-600 file:text-red-600 file:hover:bg-red-300 file:hover:text-red-700',
}]

export const inputDefaultVariants = {
  color: 'neutral',
  variant: 'outline',
  size: 'lg',
}

const input: DeepPartial<typeof theme> = {
  slots: { ...inputSlots as any },
  variants: { ...inputVariants as any },
  compoundVariants: [...inputCompoundVariants as any],
  defaultVariants: { ...inputDefaultVariants as any },
}

export default input
